// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#payment-apis .pay-now {\n  text-transform: initial;\n  font-size: 22px;\n  line-height: 48px;\n  height: auto;\n  background-color: #3f9ffd !important;\n}\n#payment-apis .pay-now.disabled {\n  cursor: default;\n  background-color: #dedede !important;\n}\n.errors label {\n  font-size: 15px;\n  color: #ff003b;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
